import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type TrendingTag } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetTrendingTagsQuery, getTrendingTags } from "../api/queries";
import { isChallengeTag } from "../utils";

interface TrendTagsAPI {
    data: TrendingTag[];
}

export const useGetTrendingTags = (): ApolloResult<TrendTagsAPI> => {
    const { data, loading, error } = useQuery<GetTrendingTagsQuery>(getTrendingTags);

    const currentTime = Math.floor(Date.now());
    const filterData = (data?.trendingTags ?? [])
        .filter(({ expiresAt }) => Math.floor(new Date(expiresAt).getTime()) >= currentTime)
        .sort((tag1, tag2) => {
            const tag1IsChallenge = isChallengeTag(tag1.tag);
            const tag2IsChallenge = isChallengeTag(tag2.tag);

            if (tag1IsChallenge && !tag2IsChallenge) {
                return -1;
            } else if (!tag1IsChallenge && tag2IsChallenge) {
                return 1;
            } else {
                return 0;
            }
        });
    return useMemo(
        () => ({
            data: filterData,
            loading,
            error,
        }),
        [error, filterData, loading],
    );
};
